module.exports = __webpack_public_path__ + "static/elephant-thumbnail-44f1cf2d2a41a29b6a0bdb4fe63d4973.jpg";